import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import CustomIcon from "components/customComponents/CustomIcon";
import CustomText from "components/customComponents/CustomText";
import { validatePasswordRules } from "utils/data/User";

import "css/common/password-validator.scss";

class OFormPasswordValidator extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { password, rule, namespace, t } = this.props;
    const valid = validatePasswordRules(password, [rule]);
    return (
      <div className={`password-validator ${valid ? "valid-password" : ""}`}>
        <CustomIcon
          disabledHover
          namespace={namespace}
          className="material-icons"
        >
          {valid ? "done" : "clear"}
        </CustomIcon>
        <CustomText namespace={namespace}>
          {t(`passwordRules.${rule}`)}
        </CustomText>
      </div>
    );
  }
}

OFormPasswordValidator.propTypes = {
  namespace: PropTypes.string,
  password: PropTypes.string,
  t: PropTypes.func.isRequired,
  rule: PropTypes.oneOf([
    "min8",
    "lowercase",
    "uppercase",
    "digits",
    "noSpaces",
  ]),
};

export default withTranslation("login")(OFormPasswordValidator);
